import { Dropdown } from 'primereact/dropdown';
import React from 'react'
import { useSelector } from 'react-redux';

const OtherIssFields = ({ form, handleChange, error, data }) => {

  const issueByData = useSelector((state) => state.getGenMaster?.user?.data) || [];
  const projectData = useSelector((state) => state.getProject?.user?.data) || [];

  const selectedProject = projectData.find(
    (p) => p._id === form.project_id
  );

  return (
    <>
      <div className='row'>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Project <span className="login-danger">*</span></label>
            <Dropdown
              value={form.project_id}
              options={projectData?.map((e) => ({
                label: e.project_no ? `${e.name} (${e.project_no})` : e.name,
                value: e._id,
              }))}
              onChange={e => handleChange({ target: { name: 'project_id', value: e.value } })}
              placeholder="Select Project"
              filter
              className="w-100"
              // disabled={data?._id}
            />
            <div className='error'>{error?.project_id}</div>
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Project No</label>
            <input
              type="text"
              name="manual_pro_no"
              placeholder="Enter Project No"
              value={form?.manual_pro_no || ""}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>
        {data?._id && (
          <div className="col-12 col-md-4 col-xl-4">
            <div className="input-block local-forms">
              <label>Issue No.</label>
              <input
                type='text'
                className="form-control"
                value={data?.voucher_no}
                readOnly
              />
            </div>
          </div>
        )}
      </div>
      <div className='row'>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms">
            <label>Date <span className="login-danger">*</span></label>
            <input
              type='date'
              className="form-control"
              name='trans_date'
              onChange={handleChange}
              value={form.trans_date}
            />
            {error.trans_date && <div className="error">{error.trans_date}</div>}
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Other Issue By <span className="login-danger">*</span></label>
            <Dropdown
              value={form.master_id}
              options={issueByData?.map(e => ({ label: e.name, value: e._id }))}
              onChange={e => handleChange({ target: { name: 'master_id', value: e.value } })}
              placeholder="Select Other Issue By"
              filter
              className="w-100"
            />
            {error.master_id && <div className="error">{error.master_id}</div>}
          </div>
        </div>
      </div>
    </>
  )
}

export default OtherIssFields